/**
 * checking text is JP language
 * @param input
 * @return {boolean}
 */
import moment from 'moment-timezone'

moment.locale('ja')

export const isJapanese = (input) => {
  const regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g

  return regex.test(input)
}

/**
 * alert message to show user, they go over limit of text box
 * @param NUMBER
 */
export const alertOverMaxLength = (NUMBER) => {
  return alert(`TEXT ${ NUMBER }`)
}

/**
 * set default Date
 * @return {string}
 */
export const defaultDate = () => {
  const time = moment.tz(Date.now(), 'Asia/Tokyo')
  const year = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', { era: 'short' }).format(time.format('x'))
  const monthDay = time.format('MMMDo（dd）')

  return year.substring(0, 3)+　'年' + monthDay
}

/**
 * remove all html Tags
 * @param text
 * @return {*}
 */
export const removeHtml = (text) => {
  return text.replace(/(<([^>]+)>)/ig, '')
}

/**
 * remove all style inline
 * @param element
 */
export const removeAllInlineStyle = (element) => {
  const children = element.childNodes
  //
  for (let i = 0; i < children.length; i++) {
    if ('style' in children[i]) {
      children[i].style.cssText = ''
    }
  }
}